import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, CircularProgress } from '@mui/material';
import { fetchWithToken } from '../../../api/apiutils';

const SummaryDetailsModal = ({ open, onClose, analysisId }) => {
  const [loading, setLoading] = useState(true);
  const [summaryData, setSummaryData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSummaryDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchWithToken(`/api/lots/analysis/details?Id=${analysisId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch log details');
        }
        const result = await response.json();
        setSummaryData(result);
        console.log("Received Summary Data: ", result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (open && analysisId) {
      fetchSummaryDetails();
    } else {
      setSummaryData(null);
    }
  }, [open, analysisId]);

  if (loading) {
    return (
      <Modal open={open} onClose={onClose}>
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
        </Box>
      </Modal>
    );
  }

  if (error) {
    return (
      <Modal open={open} onClose={onClose}>
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <Typography color="error">{error}</Typography>
        </Box>
      </Modal>
    );
  }

  const summary = summaryData?.summary || {};
  const logs = summaryData?.logs || [];

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ p: 4, backgroundColor: 'white', maxWidth: '80%', maxHeight: '80vh', overflowY: 'auto', margin: 'auto', mt: 10, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          Результаты анализа
        </Typography>
        {summary ? (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Работа/Услуга</TableCell>
                  <TableCell>Документация</TableCell>
                  <TableCell>Требования</TableCell>
                  <TableCell>Обязательства</TableCell>
                  <TableCell>Запрос</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{summary.job || 'Нет данных'}</TableCell>
                  <TableCell>{summary.documentation || 'Нет данных'}</TableCell>
                  <TableCell>
                    {Array.isArray(summary.requirement) && summary.requirement.length > 0 ? (
                      <ul>
                        {summary.requirement.map((req, index) => (
                          <li key={index}>{req}</li>
                        ))}
                      </ul>
                    ) : 'Нет данных'}
                  </TableCell>
                  <TableCell>
                    {Array.isArray(summary.obligations) && summary.obligations.length > 0 ? (
                      <ul>
                        {summary.obligations.map((obl, index) => (
                          <li key={index}>{obl}</li>
                        ))}
                      </ul>
                    ) : 'Нет данных'}
                  </TableCell>
                  <TableCell>{summary.query || 'Нет данных'}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography>Нет данных для отображения</Typography>
        )}
      </Box>
    </Modal>
  );
};

export default SummaryDetailsModal;
